import useSWR from 'swr'
// import useSWRInfinite from 'swr/infinite'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosError, AxiosResponse } from 'axios'
import { useCallback } from 'react'
import { useCookies } from 'react-cookie'
import { STORAGE_PREFIX } from '../../config'
import { LOCAL_EXECUTION } from '../../utils/featureFlag'

export interface useEventsProps {
  event: EventInfo | undefined
  events: AxiosResponse<FetchResponse> | undefined
  isLoading: boolean
  isError: AxiosError
}

export interface EventInfo {
  id?: number
  nome: string
  cliente: string
  clienteId?: number
  data: string
  local?: string
  pracaId?: string
  praca?: string
  endereco?: string
  latitude?: string
  longitude?: string
  uf?: string
  imagens?: { resolution: number; url: string }[]
  taxaSaqueTED?: number
}

interface ResponseBody {
  data: EventInfo[]
}

interface FetchResponse {
  success: boolean
  body: ResponseBody
}

export const useEvent = (id: number): useEventsProps => {
  const url: string = `producer/analytics/eventInfo?eventId=${id}`

  // Only fetch once an auth token is available. The token is delivered
  // asynchronously by the native app via the `get-user-token` bridge and
  // written to the `userJWT` cookie. Firing the request before it lands
  // results in a 401 ("eventInfo"), so we gate the SWR key on the cookie.
  const tokenKey = STORAGE_PREFIX + 'userJWT'
  const [cookies] = useCookies([tokenKey])
  const hasToken = LOCAL_EXECUTION || Boolean(cookies[tokenKey])

  const fetchData = useCallback(async (): Promise<AxiosResponse<any>> => {
    return await APIDecoratorWithBaseURI().get(url)
  }, [url])

  const { data, error, isLoading } = useSWR(hasToken ? url : null, fetchData)

  return {
    event: data?.data?.body,
    events: undefined,
    isLoading: isLoading || !hasToken,
    isError: error,
  }
}

export const useEvents = async (url: any) => {
  return await APIDecoratorWithBaseURI().get(url)
}
